var exports = {
  "NA": "x804f0401--9b831c--vertical-container",
  "kL": "x804f0401--9b831c--container",
  "Sl": "x804f0401--9b831c--image",
  "h_": "x804f0401--9b831c--description",
  "XI": "x804f0401--9b831c--action",
};

module.exports = exports;
